// A question from the AI agent that disables the composer (`data-blocking`) takes focus onto its
// first button; once answered and gone, focus returns to the composer. Only when focus isn't
// elsewhere, like in the flow editor.

export default {
  ChatActionFocus: {
    mounted() {
      if (!this.el.hasAttribute('data-blocking')) return;

      const composer = document.getElementById(this.el.dataset.composer);
      const focusButton = () => {
        if (document.activeElement === document.body) this.el.querySelector('button')?.focus();
      };

      // The just-disabled composer still holds focus. The browser moves it to the page a moment
      // later, and would undo anything we focused before that settles.
      if (document.activeElement === composer) {
        composer.addEventListener('focusout', () => requestAnimationFrame(focusButton), { once: true });
      } else {
        focusButton();
      }
    },

    destroyed() {
      if (document.activeElement === document.body) document.getElementById(this.el.dataset.composer)?.focus();
    },
  },
};
